import { render } from "./TrendChart.vue?vue&type=template&id=b360b0d6&scoped=true"
import script from "./TrendChart.vue?vue&type=script&lang=js"
export * from "./TrendChart.vue?vue&type=script&lang=js"

import "./TrendChart.vue?vue&type=style&index=0&id=b360b0d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b360b0d6"]])

export default __exports__